// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 270) return "assets/js/vendor-react.d9ab8f7e.chunk.js";
	if (chunkId === 216) return "assets/js/vendors.34dea36f.chunk.js";
	// return url for filenames based on template
	return "" + chunkId + ".js";
};